<template>
  <div class="text-input__wrapper">
    <input
      :placeholder="placeholder"
      :value="value"
      type="text"
      class="input"
      :style="{ padding: `16px ${rightPadding}px 14px ${leftPadding}px` }"
      :disabled="disabled"
      @input="
        event => {
          $emit('changedValue', event.target.value);
        }
      "
      @focus="$emit('focus')"
      @blur="$emit('blur')"
    />
    <div ref="iconLeft" class="text-input__icon text-input__icon_left">
      <slot name="leftIconChild" />
    </div>
    <div ref="iconRight" class="text-input__icon text-input__icon_right">
      <slot name="rightIconChild" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'TextInput',
  props: {
    placeholder: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      leftPadding: 0,
      rightPadding: 0
    };
  },
  mounted() {
    this.leftPadding =
      this.$refs.iconLeft.offsetWidth === 0 ? 13 : this.$refs.iconLeft.offsetWidth + 26;
    this.rightPadding =
      this.$refs.iconRight.offsetWidth === 0 ? 13 : this.$refs.iconRight.offsetWidth + 26;
  }
};
</script>

<style lang="scss" scoped>
.text-input {
  &__wrapper {
    position: relative;
  }

  &__icon {
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &_left {
      left: 13px;
    }

    &_right {
      right: 13px;
    }
  }
}

input::placeholder,
input:disabled {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.3px;
  color: #76767b;
}

input {
  width: 100%;
  border: none;
  background: transparent;
  font-family: 'Helvetica', sans-serif;
}
</style>
